import { brand } from "../context";

const normal_gap = ".75rem";
const half_gap = ".375rem";
const normal_border_radius = "8px";

const base_border_radius_table = {
  easy: normal_gap,
  default: normal_gap,
  mse: "",
  isg: "",
  cst: "",
  mycarte: "",
  soulatravel: "",
  corporatetravelclub: "",
  unionshopper: "",
  tabula_rasa: "",
  atlantic: "",
  festival: "",
  knoxtravel: "",
  traveldealfinders: "",
  tmdh: "10px",
  thehotelco: "",
  clubseacret: "",
  infinite: normal_gap,
  rocs: half_gap,
  fightzone: "",
  travellingtime: "",
  htg: "",
  fluturolire: "",
  flymenow: "",
  truecations: "",
  innstanttravel: 0,
  uab: normal_gap,
};

export function getBorderRadius(brandParam) {
  const brandLcl = brandParam ? brandParam : brand;
  if (
    typeof base_border_radius_table[brandLcl] === "number" ||
    base_border_radius_table[brandLcl]
  ) {
    return base_border_radius_table[brandLcl];
  }
  return normal_border_radius;
}
